import stringSchema from "@/lib/utils/stringSchema";
import { z } from "zod";

const formSchema = z.object({
  name: stringSchema({ key: "Name", required: true }),
  initials: stringSchema({ key: "Initials", required: true }),
  sender_email: stringSchema({
    type: "email",
    key: "Sender Email",
    required: true,
  }),
  currency: stringSchema({ key: "Currency", required: true }),
  rate_us: z.boolean(),
  is_budget_visible: z.boolean(),
  rating_show_in_ticket: z.boolean(),
  external_quality_score: z.boolean(),
  ticket_inactivity_notification: z.boolean(),
  azure_devops_integration: z.boolean(),
  status: z.string(),
  crm_id: z.union([z.number(), z.string()]).optional(),
  flexi_thresholds: z.array(z.number()),
  avatar: z.any().nullable().optional(),
});

export default formSchema;
